<template>
	<div class="iain-title">
		<div class="iain-title-prepend">
			<div class="iain-title-prepend-title">{{ title }}</div>
			<div class="iain-title-prepend-tips">{{ tip }}</div>
		</div>
		<div class="iain-title-append">
			<slot name="append" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'iain-title',
		props: {
			title: {
				type: String,
				default: ''
			},
			tip: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss">
	.iain-title {
    display: flex;
    align-items: center;
    justify-content: space-between;;
		padding-bottom: 20px;
		padding-left: 12px;

		.iain-title-prepend {
			display: flex;
    align-items: center;
			flex-shrink: 0;

			.iain-title-prepend-title {
				position: relative;
				font-size: 30px;
				font-weight: bold;
				color: #222222;

				&::after {
					content: '';
					position: absolute;
					top: 50%;
					left: -12px;
					width: 5px;
					height: 28px;
					transform: translate(0, -50%);
					border-radius: 3px;
					background: #0076FF;
				}
			}

			.iain-title-prepend-tips {
				padding-left: 12px;
				color: #EEEEEE;
			}
		}

		.iain-title-append {
			flex-shrink: 0;
		}
	}
</style>
